import { gql } from "apollo-boost"

export const GET_APPROVED_AND_INVESTMENT_DISTRIBUTION = gql`
  query ApprovedAndInvestmentDistribution($id: ID!) {
    Submission(id: $id) {
      approved
      alliedOne
      alliedTwo
      concepts {
          id
          totalUnits
          unitCost
          budgeted
          investmentDistribution {
              id
              type
              name
              percentage
          }
      }
    }
  }
`